/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImportAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function ImportAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/DocumentTemplates/Templates/ImportAction/Content/ImportAction",
  onSubmit,
  disabled
  
}) {
let importSubmitData = fromData.useDataSubmit({ viewPath,
context: 'import',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 text="Import"
 data="import"
 onClick={importSubmitData}
 disabled={disabled}
/>
{children}
</React.Fragment>)
}